export enum Shade {
    Unshaded = 0,
    Shade1 = 1,
    Shade2 = 2,
    Shade3 = 3,
    Shade4 = 4,
    Shade5 = 5,
    Shade6 = 6,
    Shade7 = 7,
    Shade8 = 8,
}

export const MAX_COLOR_RGB = 255;
export const MINIMUM_TEXT_CONTRAST = 4.5;
export const REDUCED_MINIMUM_TEXT_CONTRAST = 8;
export const REDUCED_MINIMUM_TEXT_CONTRAST_UX_SIMPLIFICATION = 6;
export const MINIMUM_GRAYSCALE_TEXT_CONTRAST = 11;
export const TEXT_CONTRAST_WHITE_PREFERENCE_BUFFER = 0.3;

// Maximum number of iterations the algorithm for grayscale
// text color can run.
// Calculated by dividing max color val (255) by STEP_LENGTH (5)
export const MAX_ITERATIONS_TEXT_GRAYSCALE = 51;
export const STEP_LENGTH = 5;

/**
 * These tables dictate the factor by which a color is darkened or lightened. The values
 * are the same as those used in the Fluent color algorithm (see link).
 *
 * https://github.com/microsoft/fluentui/blob/64746a5ab84583b5c4570570b0460f6c70bab25a/packages/react/src/utilities/color/shades.ts
 */
export const WhiteShadeTable = [0.537, 0.349, 0.216, 0.184, 0.145, 0.082, 0.043, 0.027]; // white fg
export const BlackTintTable = [0.537, 0.45, 0.349, 0.216, 0.184, 0.145, 0.082, 0.043]; // black fg
export const LumTintTable = [0.88, 0.77, 0.66, 0.55, 0.44, 0.33, 0.22, 0.11]; // light (strengthen all)
export const LumShadeTable = [0.11, 0.22, 0.33, 0.44, 0.55, 0.66, 0.77, 0.88]; // dark (soften all)
export const ColorTintTable = [0.96, 0.84, 0.7, 0.4, 0.12]; // default soften
export const ColorShadeTable = [0.1, 0.24, 0.44]; // default strengthen
// If the given shade's luminance is below/above these values, we'll swap to using the White/Black tables above
export const LowLuminanceThreshold = 0.2;
export const HighLuminanceThreshold = 0.94;
